import { useClient } from 'urql';
import { DocumentNode } from 'graphql/language';
import { CombinedError } from '@urql/core';

import { useCore } from '@phoenix/core/frontend/shared/feature/context/core.context';
import { useQueryContextMemo } from '@phoenix/team-m/dashboard/frontend/shared/use-query-context-memo';

export const useQueryFetcher = <T>(document: DocumentNode) => {
  const stihlId = useCore().auth.user?.stihl_id;
  const client = useClient();
  const queryVariables = {
    stihlId,
    context: useQueryContextMemo(),
    paused: !stihlId,
  };

  return async (variables?: Record<string, unknown>) => {
    const response = await client.query<T>(document, { ...queryVariables, ...variables }).toPromise();

    if (response.error) {
      throw new CombinedError(response.error);
    }

    return response;
  };
};
